import { createContext, useEffect, useState } from "react";
import { Button, Card, Form } from "react-bootstrap";
import CodeParameters from "./FormComponents/CodeParameters";
import components from "./FormComponents/index.js";
import styles from "./Parameters.module.css";

const DynamicFormUtilsDataContext = createContext([
  {
    languages: [
      {
        value: "fr",
        name: "Français",
      },
      {
        value: "en",
        name: "Anglais",
      },
    ],
  },
  () => {},
]);

function ParameterSchemeObjectEditor({ object, setObject, name, setName }) {
  const [label, setLabel] = useState(object.label || "");
  const [type, setType] = useState(object.type || Object.keys(components)[0]);
  const [elementModel, setElementModel] = useState(object.elemModel || {});

  useEffect(() => {
    const newObject = {
      label: label,
      type: type,
      default: components[type]["default"],
    };
    if (components[type]["hasElemModel"]) {
      newObject["elemModel"] = elementModel;
    }
    setObject(newObject);
  }, [label, type, elementModel]);

  if (Object.keys(object).length == 0) {
    return <></>;
  }
  return (
    <Card style={{ padding: "10px" }}>
      <Card.Text>
        <Form.Control
          style={{
            width: "50%",
            display: "inline-block",
          }}
          value={name}
          onChange={(x) => setName(x.target.value)}
          placeholder="Nom"
          type="text"
        />{" "}
        :
        <Card style={{ padding: "10px" }}>
          <Card.Text>
            <Form.Label>label :</Form.Label>
            <Form.Control
              value={label}
              onChange={(x) => setLabel(x.target.value)}
              placeholder="Label"
              type="text"
            />
            <Form.Label>type :</Form.Label>
            <Form.Select onChange={(x) => setType(x.target.value)}>
              {Object.keys(components).map((x, i) => (
                <option value={x} key={i}>
                  {x}
                </option>
              ))}
            </Form.Select>
            {components[type]["hasElemModel"] ? (
              <>
                <Form.Label>elemModel :</Form.Label>
                <ParameterSchemeEditor
                  model={elementModel}
                  setModel={setElementModel}
                />
              </>
            ) : (
              ""
            )}
          </Card.Text>
        </Card>
      </Card.Text>
    </Card>
  );
}

function ParameterSchemeEditor({ model, setModel }) {
  /**
   * Editor for the parameters models that uses for each key of the parameters object a ParameterSchemeObjectEditor
   */

  return (
    <div>
      {Object.keys(model).map((k, i) => (
        <div key={i}>
          <ParameterSchemeObjectEditor
            key={i}
            object={model[k]}
            setObject={(x) => {
              const newModel = { ...model };
              newModel[k] = x;
              setModel(newModel);
            }}
            name={k}
            setName={(x) => {
              const newModel = { ...model };
              newModel[x] = model[k];
              delete newModel[k];
              setModel(newModel);
            }}
          />
          <Button
            variant="danger"
            onClick={() => {
              const newModel = { ...model };
              delete newModel[k];
              setModel(newModel);
            }}
          >
            Supprimer
          </Button>
        </div>
      ))}
      <Button
        onClick={() => {
          const newModel = { ...model };
          newModel[`new${Object.keys(model).length}`] = {
            label: "",
            type: Object.keys(components)[0],
            default: components[Object.keys(components)[0]]["default"],
          };
          setModel(newModel);
        }}
      >
        Ajouter
      </Button>
    </div>
  );
}

function DynamicForm({
  parametersModel,
  formData,
  onParameterChange,
  utilsData,
  id,
}) {
  return (
    <Card className={styles.param_group}>
      {parametersModel
        ? Object.keys(parametersModel).map((k, i) => {
            const Module = components[parametersModel[k]["type"]]["component"];

            return (
              <div key={k + i}>
                {!(typeof formData[k] == "object" && formData[k]["is_code"]) ||
                (typeof formData[k] == "object" &&
                  parametersModel[k]["type"] === "code") ? (
                  <div className={styles.form_group}>
                    <Module
                      parameters={parametersModel[k]}
                      value={
                        //formData[k]
                        formData[k] === undefined
                          ? parametersModel[k]["default"]
                          : formData[k]
                      }
                      onChange={(x) => {
                        const newParameters = { ...formData };
                        if (parametersModel[k]["updateUtilsDataField"]) {
                          utilsData[1]((y) => {
                            return {
                              ...y,
                              [parametersModel[k]["updateUtilsDataField"]]: x,
                            };
                          });
                        }
                        newParameters[k] = x;
                        onParameterChange(newParameters);
                      }}
                      utilsData={utilsData}
                      id={id}
                    />
                    {parametersModel[k].canBeCoded && (
                      <div className={styles.code_switch_container}>
                        <span
                          onClick={() => {
                            const newParameters = { ...formData };
                            newParameters[k] = {
                              code: newParameters[k] || "",
                              is_code: true,
                            };
                            onParameterChange(newParameters);
                          }}
                          className={styles.code_switch_button}
                        >
                          {/*<BsCodeSquare/>*/}
                          Code
                        </span>
                      </div>
                    )}
                  </div>
                ) : (
                  <>
                    <CodeParameters
                      parametersModel={parametersModel[k]}
                      parameters={{
                        ...formData[k],
                        language: parametersModel[k].codeLanguage,
                      }}
                      onParameterChange={(x) => {
                        const newParameters = { ...formData };
                        newParameters[k] = x;
                        onParameterChange(newParameters);
                      }}
                      utilsData={utilsData}
                    />
                    <div className={styles.code_switch_container}>
                      <span
                        onClick={() => {
                          const newParameters = { ...formData };
                          try {
                            newParameters[k] = JSON.parse(
                              newParameters[k]["code"]
                            );
                          } catch (e) {
                            newParameters[k] = newParameters[k]["code"];
                          }
                          onParameterChange(newParameters);
                        }}
                        className={styles.code_switch_button}
                      >
                        {/*<BsMenuButtonWide/>*/}
                        Formulaire
                      </span>
                    </div>
                  </>
                )}
              </div>
            );
          })
        : ""}
    </Card>
  );
}

export { DynamicForm, ParameterSchemeEditor, DynamicFormUtilsDataContext };
